let pc_pv_threshold = 100
if (new Date() > new Date(2024, 0, 1)) {
  pc_pv_threshold = 125
}

export { pc_pv_threshold }
